module.exports = __webpack_public_path__ + "media/images/icons/ic-contact-persons-77d259b4f99d3ded69e2bc036dfc7f7b.svg";